// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/tenants/kiosk-permits/styles.scss
// module id = 1068
// module chunks = 65